import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const CustomerAuthContext = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [token, setToken] = useState(sessionStorage.getItem('kyis_staff_portal_token') || localStorage.getItem('kyis_customer_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      axios.get(`${API_URL}/api/portal/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => setCustomer(r.data))
        .catch(() => { logout(); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post(`${API_URL}/api/portal/login`, { email, password });
    const { access_token, user } = res.data;
    localStorage.setItem('kyis_customer_token', access_token);
    setToken(access_token);
    setCustomer(user);
    return user;
  };

  const register = async (payload) => {
    const res = await axios.post(`${API_URL}/api/portal/register`, payload);
    if (res.data.setup_required) return res.data;
    const { access_token, user } = res.data;
    localStorage.setItem('kyis_customer_token', access_token);
    setToken(access_token);
    setCustomer(user);
    return user;
  };

  const endStaffAccess = async () => {
    try { await axios.post(`${API_URL}/api/portal/staff-session/end`, {}, { headers: { Authorization: `Bearer ${token}` } }); } catch {}
    const destination = sessionStorage.getItem('kyis_staff_portal_return') || '/admin/contacts';
    sessionStorage.removeItem('kyis_staff_portal_token'); sessionStorage.removeItem('kyis_staff_portal_return');
    window.location.assign(destination.startsWith('/admin/contacts') ? destination : '/admin/contacts');
  };

  const logout = () => {
    if (sessionStorage.getItem('kyis_staff_portal_token')) { endStaffAccess(); return; }
    localStorage.removeItem('kyis_customer_token');
    setToken(null);
    setCustomer(null);
  };

  const updateProfile = async (data) => {
    const res = await axios.put(`${API_URL}/api/portal/profile`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setCustomer(res.data);
    return res.data;
  };

  const changePassword = async (currentPassword, newPassword) => {
    await axios.post(`${API_URL}/api/portal/change-password`,
      { current_password: currentPassword, new_password: newPassword },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    setCustomer(prev => ({ ...prev, must_change_password: false }));
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, token, loading, login, register, logout, endStaffAccess, updateProfile, changePassword }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomerAuth = () => useContext(CustomerAuthContext);
